import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DocmanFolderModel } from '../services/docman.model.folder';
import { UiService } from '../../../core/services/core.ui.service';
import * as _ from 'lodash';

@Component({
  selector: 'folder-add-modal',
  template: require('./folder.add.modal.html')
})
export class FolderAddModalComponent implements OnInit {
  @Input() parentFolder: any;
  @Input() currentFolder: any;
  @Input() rootFolder: any;
  @Input() folders: any[];
  @Input() project: any;

  @Output() onAdd = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  newFolder: any;
  PublicPrivate: any;
  formErrors: any;
  canBePublic: boolean = false;

  constructor(
    private docmanFolderModel: DocmanFolderModel,
    private uiService: UiService
  ) {}

  ngOnInit(): void {
    this.newFolder = this.docmanFolderModel.createFolderStructure(0, '', false, this.parentFolder, this.project.id);
    this.PublicPrivate = {
      'Public': true,
      'Private': false
    };
    this.setFolderVisibility();
  }

  setIsPublic(value: boolean): void {
    this.newFolder.isPublic = value;
  }

  saveFolder(): Promise<void> {
    let success = false;

    this.newFolder.parentFolderId = (this.currentFolder.isRoot && this.currentFolder.id === this.newFolder.parentFolderId) ? 0 : this.newFolder.parentFolderId;

    // Validate folder first
    this.formErrors = this.docmanFolderModel.validateFolder(this.newFolder);
    if (!_.isEmpty(this.formErrors)) {
      this.uiService.message.showError('Folder validation failed. The folder name cannot contain slashes');
      return Promise.resolve();
    }

    return this.docmanFolderModel.saveFolder(this.newFolder, true)
      .then(() => {
        success = true;
        this.uiService.message.showSuccess(`Folder settings for ${_.get(this.newFolder, 'folderName', '(unknown)')} have been updated successfully`);
        this.onAdd.emit(this.newFolder);
      })
      .catch((err) => {
        let msg = '';
        if (err.data?.folderName?.length > 0) {
          if (err.data.folderName[0].type === 'required') {
            msg = 'Folder name is required';
          } else if (err.data.folderName[0].type === 'length') {
            msg = 'Folder name must have at least 5 characters';
          }
        }
        this.uiService.message.showError(`Error saving folder ${_.get(this.newFolder, 'folderName', '(unknown)')}: ${msg}`);
        this.onClose.emit();
      });
  }

  private setFolderVisibility(): void {
    // A folder can be set to "public" if:
    // a) it's the root folder
    // b) it's not the root folder and its parent folder is NOT private
    const parentFolder = this.newFolder.parentFolderId === 0 ? this.rootFolder : _.find(this.folders, { id: this.newFolder.parentFolderId });
    this.canBePublic = !!parentFolder && parentFolder.isPublic;

    if (!this.canBePublic) {
      this.newFolder.isPublic = false;
    }
  }
}
